var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferenceBgCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vector 30",
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3617 1C10.9092 2.05556 11.61 4.43333 10.0333 5.5C8.06237 6.83333 7.73389 6.83333 8.06237 8.33333C8.39085 9.83333 9.54054 11.1667 7.56965 11C5.59875 10.8333 3.29938 9.33333 2.31393 11C1.52557 12.3333 1.10949 13.5556 1 14",
    stroke: "white",
    strokeOpacity: 0.52,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferenceBgCurve);
export default __webpack_public_path__ + "static/media/preferenceBgCurve.3fa63b3cd261d0882711c445f661a746.svg";
export { ForwardRef as ReactComponent };